<p-iconfield>
  <p-inputicon class="pi pi-search"/>
  <input [formControl]="this.control()" [placeholder]="'action.search' | translate" fluid pInputText type="text"
         variant="outlined"/>
</p-iconfield>

